"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NamespaceProvider = exports.NamespaceContext = void 0;
var react_1 = __importDefault(require("react"));
exports.NamespaceContext = react_1.default.createContext(undefined);
var NamespaceProvider = function (_a) {
    var namespace = _a.namespace, _b = _a.nested, nested = _b === void 0 ? false : _b, children = _a.children;
    var parent = react_1.default.useContext(exports.NamespaceContext);
    var result = nested ? "".concat(parent, ".").concat(namespace) : namespace;
    return react_1.default.createElement(exports.NamespaceContext.Provider, { value: result }, children);
};
exports.NamespaceProvider = NamespaceProvider;
